//@flow
import Constants from '../constants';
import UrlData from '../Utils/url-data';
import Dispatcher from '../dispatcher';
import axios from 'axios';
import TrackJs from '../Utils/trackjs-interface';

export default {
  fetchMktgData() {
    const query = `query
    {
      listConfigItems {
        configItems {
          _id
          createdAt
          updatedAt
          type
          status
          title
          priority
          activationConfig {
            operator
            params {
              operator
              conditions {
                type
                value
                name
                match
                start
                end
              }
            }
          }
          helloBarConfig {
            text
            link
            meta
          }
          bannerConfig {
            items {
              className
              imageSmall
              imageMedium
              imageLarge
              imageXlarge
              imageXXlarge
              title
              text1
              text2
              text3
              text4
              link
              isExternalLink
              styles
            }
          }
        }
      }
    }
    `;
    const urlBase = UrlData.getEngineApiUrl();
    const config = {
      method: 'post',
      url: `${urlBase}/graphql`,
      data: {query},
    };
    return axios(config)
      .then(response => {
        const configItems = response.data.data && response.data.data.listConfigItems.configItems
          ? response.data.data.listConfigItems.configItems
          : null;
        if (configItems) {
          Dispatcher.dispatchAction(
            Constants.GET_MKTG_DATA_SUCCESS,
            {configItems}
          );
        }
        return {response};
      })
      .catch(error => {
        TrackJs.console.debug('fetchMktgData error: ' + JSON.stringify(error));
        // eslint-disable-next-line promise/no-return-wrap
        return Promise.reject({error});
      });
  },
};
